import {
    Component, OnInit, Input, Output, ContentChildren, EventEmitter, QueryList, TemplateRef,
    NgModule, AfterContentInit
} from '@angular/core';
import {PrimeTemplate, SharedModule} from "primeng/components/common/shared";
import {Message} from "primeng/components/common/api";
import {DomSanitizer} from "@angular/platform-browser";
import {CommonModule} from "@angular/common";
import {ButtonModule} from "primeng/components/button/button";
import {ProgressBarModule} from "primeng/components/progressbar/progressbar";
import {MessagesModule} from "primeng/components/messages/messages";

@Component({
    selector: 'p-fileUpload',
    templateUrl: './file-upload-input.component.html',
    styleUrls: ['./file-upload-input.component.scss']
})
export class FileUpload implements OnInit {

    @Input() name: string;

    @Input() multiple: boolean;

    @Input() accept: string;

    @Input() disabled: boolean;

    @Input() maxFileSize: number;

    @Input() invalidFileSizeMessageSummary: string = '{0}: Invalid file size, ';

    @Input() invalidFileSizeMessageDetail: string = 'maximum upload size is {0}.';

    @Input() style: string;

    @Input() styleClass: string;

    @Input() previewWidth: number = 50;

    @Input() chooseLabel: string = 'Choose';

    @Input() files: File[];

    @Output() filesChange: EventEmitter<File[]> = new EventEmitter();

    @Output() onFileSelected: EventEmitter<boolean> = new EventEmitter();

    public progress: number = 0;

    public dragHighlight: boolean;

    public msgs: Message[];

    constructor(private sanitizer: DomSanitizer) {
    }

    ngOnInit() {
        this.files = [];
    }

    onChooseClick(event, fileInput) {
        fileInput.value = null;
        fileInput.click();
    }

    onFileSelect(event) {
        this.msgs = [];
        if (!this.multiple) {
            this.files = [];
        }

        let files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
        for (let i = 0; i < files.length; i++) {
            let file = files[i];
            if (this.validate(file)) {
                this.files.push(files[i]);
            }
        }
        this.onFileSelected.emit(true);
        this.filesChange.emit(this.files);
    }

    validate(file: File): boolean {
        if (this.maxFileSize && file.size > this.maxFileSize) {
            this.msgs.push({
                severity: 'error',
                summary: this.invalidFileSizeMessageSummary.replace('{0}', file.name),
                detail: this.invalidFileSizeMessageDetail.replace('{0}', this.formatSize(this.maxFileSize))
            });
            return false;
        }

        return true;
    }

    isImage(file: File): boolean {
        return /^image\//.test(file.type);
    }

    onImageLoad(img: any) {
        window.URL.revokeObjectURL(img.src);
    }

    clear() {
        this.files = [];
    }

    remove(index: number) {
        this.onFileSelected.emit(false);
        this.files.splice(index, 1);
    }

    hasFiles(): boolean {
        return this.files && this.files.length > 0;
    }

    onDragEnter(e) {
        if (!this.disabled) {
            e.stopPropagation();
            e.preventDefault();
        }
    }

    onDragOver(e) {
        if (!this.disabled) {
            this.dragHighlight = true;
            e.stopPropagation();
            e.preventDefault();
        }
    }

    onDragLeave(e) {
        if (!this.disabled) {
            this.dragHighlight = false;
        }
    }

    onDrop(e) {
        if (!this.disabled) {
            this.dragHighlight = false;
            e.stopPropagation();
            e.preventDefault();

            this.onFileSelect(e);
        }
    }

    formatSize(bytes) {
        if (bytes == 0) {
            return '0 B';
        }
        let k = 1000,
            dm = 3,
            sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
}

@NgModule({
    imports: [CommonModule, SharedModule, ButtonModule, ProgressBarModule, MessagesModule],
    exports: [FileUpload, SharedModule, ButtonModule, ProgressBarModule, MessagesModule],
    declarations: [FileUpload]
})
export class FileUploadModule {
}


// WEBPACK FOOTER //
// ./src/app/core/commons/file-upload-input/file-upload-input.component.ts